import React, { useMemo } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const SpendComparisonCard = ({ currentMonthTransactions, previousMonthTransactions }) => {
  const theme = useTheme();

  const percentageChange = useMemo(() => {
    const currentTotal = currentMonthTransactions.reduce((sum, t) => sum + t.amount, 0);
    const previousTotal = previousMonthTransactions.reduce((sum, t) => sum + t.amount, 0);

    if (previousTotal > 0) {
      return ((currentTotal - previousTotal) / previousTotal) * 100;
    }
    return currentTotal > 0 ? 100 : 0;
  }, [currentMonthTransactions, previousMonthTransactions]);

  const isUp = percentageChange > 0;
  const ArrowIcon = isUp ? ArrowUpwardIcon : ArrowDownwardIcon;
  const iconColor = isUp ? theme.palette.overage.main : theme.palette.secondary.main;

  return (
    <Paper elevation={3} sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" color="text.secondary">
        vs. Previous Month
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', my: 1 }}>
        <ArrowIcon style={{ color: iconColor, fontSize: '2.25rem' }} />
        <Typography variant="h4" sx={{ ml: 1, color: iconColor }}>
          {`${Math.abs(percentageChange).toFixed(0)}%`}
        </Typography>
      </Box>
    </Paper>
  );
};

export default SpendComparisonCard;